import { merge } from 'lodash';
import { Components, Theme } from '@mui/material';
import { Button } from './Button';

export function ComponentsOverrides(theme: Theme): Components {
    return merge(Button(theme));
}
